export const adminDashboard = {
  'admin.dashboard.title': 'Dashboard Amministratore',
  'admin.dashboard.subtitle': 'Panoramica della piattaforma e metriche chiave',
  'admin.dashboard.totalEarnings.lifetime': 'Guadagni Totali a Vita',
  'admin.dashboard.totalEarnings.lastMonth': 'Guadagni del Mese Scorso',
  'admin.dashboard.additionalMetrics': 'Metriche Aggiuntive in Arrivo',
  'admin.dashboard.charts.accountsProfits': 'Storico Profitti della Piattaforma',
  'admin.dashboard.charts.commissionsOverTime': 'Storico Commissioni',
  'admin.dashboard.charts.totalEarnings': 'Guadagni Totali nel Tempo',
  'admin.dashboard.users.title': 'Utenti Totali',
  'admin.dashboard.users.active': 'Utenti Attivi',
  'admin.dashboard.users.newThisMonth': 'Nuovi Questo Mese',
  'admin.dashboard.communityValue.title': 'Valore Totale della Comunità',
  'admin.dashboard.communityValue.description': 'Valore combinato di tutti gli account utente',
  'admin.dashboard.totalEarnings.accountProfit': 'Profitto del Conto',
  'admin.dashboard.totalEarnings.commissionProfit': 'Profitto da Commissioni',
  'admin.dashboard.totalEarnings.description': 'Guadagni combinati della piattaforma fino ad oggi',
  'admin.dashboard.lastMonthEarnings.description': 'Guadagni della piattaforma per',
};